import React from 'react';
import { Button, ButtonGroup, Label, Dropdown, DropdownToggle, Input, Alert, Modal, ModalHeader, ModalFooter, ModalBody, FormText, Row, Col, FormGroup } from 'reactstrap';
import { Link } from 'react-router-dom';
import { withAlert } from 'react-alert';
import { CircularProgress } from '@mui/material';

class ExportDataRowsModal extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            email: '',
            subject: '',
            message: '',
            alert_message: '',
            alert_status: 0,
            file_data: '',
            loading: false
        }
    }

    componentDidMount = () => {
        this.getFileData();
    }

    getDocumentData = () => {
        this.setState({
            loading: true,
            alert_message: '',
            alert_status: 0,
        })

        fetch(window.location.protocol + '//' + window.location.host + "/api/archive/export_documents_to_csv", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ documents: this.props.files })
        })
            .then(res => res.json())
            .then(result => {
                if (result.error) {
                    this.setState({
                        loading: false,
                        alert_message: result.error,
                        alert_status: 404
                    });
                } else {
                    this.setState({
                        alert_message: result.message,
                        alert_status: 200,
                        file_data: result.csv
                    });

                    // this.props.toggle();
                }
            });
    }

    emailDocuments = () => {
        this.setState({
            loading: true,
            alert_message: '',
            alert_status: 0,
        })

        fetch(window.location.protocol + '//' + window.location.host + "/api/email/send_email_with_file_attachments", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ documents: this.props.files, type: this.props.type, subject: this.state.subject, to_address: this.state.email, message: this.state.message })
        })
            .then(res => res.json())
            .then(result => {
                if (result.error) {
                    this.setState({
                        loading: false,
                        alert_message: result.error,
                        alert_status: 404
                    })
                } else {
                    this.setState({
                        alert_message: result.message,
                        alert_status: 200
                    })

                    setTimeout(() => this.props.toggle(), 5000);
                }
            })
    }

    getFileData = () => {
        this.setState({
            alert_message: '',
            alert_status: 0,
        })

        fetch(window.location.protocol + '//' + window.location.host + "/api/archive/export_to_csv", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ documents: this.props.files, type: this.props.type })
        })
            .then(res => res.json())
            .then(result => {
                if (result.error) {
                    this.setState({
                        loading: false,
                        alert_message: result.error,
                        alert_status: 404
                    })
                } else {
                    this.setState({
                        loading: false,
                        file_data: result.file_data
                    })
                }
            })
    }

    handleTextChange = (event) => {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }

    handlePageSelectChange = (event) => {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }

    render() {
        let groups = []
        let alert_message = {}

        if (this.state.alert_message)
            if (this.state.alert_status == 200)
                alert_message = <Alert color="success">
                    {this.state.alert_message}
                </Alert>
            else
                alert_message = <Alert color="danger">
                    {this.state.alert_message}
                </Alert>
        else
            alert_message = <div />

        return (
            <Modal isOpen={this.props.visible} toggle={this.props.toggle} className='modal-dialog'>
                <ModalHeader toggle={this.props.toggle}>
                    {`Export (${this.props.files.length}) Documents to CSV`}
                    <br />
                </ModalHeader>
                <ModalBody>
                    <Label for="email">To Address</Label>
                    <Input type="text" name="email" onChange={this.handleTextChange} />
                    <Label for="subject">Subject</Label>
                    <Input type="text" name="subject" onChange={this.handleTextChange} />
                    <Label for="message">Message</Label>
                    <Input type="textarea" name="message" onChange={this.handleTextChange} />
                    <br />
                    {alert_message}
                </ModalBody>
                <ModalFooter>
                    {this.state.file_data &&
                        <a style={{ position: 'absolute', left: '20px' }} href={"data:text/csv;charset=utf-8," + this.state.file_data} download={'exports.csv'}>
                            <Button color="success">Download</Button>
                        </a>
                    }
                    <Button
                        color="primary"
                        onClick={this.emailDocuments}
                        disabled={this.state.loading}>
                        {this.state.loading ?
                            <CircularProgress style={{ width: '1.2rem', height: '1.2rem', borderWidth: '.1em' }} />
                            :
                            "Send"
                        }
                    </Button>
                    <Button color="secondary" onClick={this.props.toggle}>Cancel</Button>
                </ModalFooter>
            </Modal>
        );
    }
}

export default withAlert()(ExportDataRowsModal);